import emailjs from '@emailjs/browser';
import { useEffect, useRef, useState } from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import * as ReactUI from 'react-bootstrap';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { backgroundThemeState, contactButtonHoverState } from '../../atoms';
import { appWrapper } from '../../hoc';
import { useContactButtonHover } from '../../util/hooks';

function ContactForm() {
  const stretchRef = useRef(null);
  const background = useRecoilValue(backgroundThemeState);
  const setContactButtonHoverState = useSetRecoilState(contactButtonHoverState);
  useEffect(() => {
    setContactButtonHoverState(background);
  }, []);

  useContactButtonHover(background);

  const [thankYouMsg, setThankYouMsg] = useState(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    emailjs
      .sendForm(
        'service_gv2rjvj',
        'template_ah3krp5',
        e.target,
        'user_PVm7OpISmI7Gc7EeDebjx'
      )
      .then(
        (result) => console.log(result.text),
        (error) => console.log(error.text)
      );

    e.target.reset();
    console.log('email sent');

    setThankYouMsg(true);
    setTimeout(() => {
      setThankYouMsg(false);
    }, 3000);
  };

  return (
    <ReactUI.Row id="main-row" className="justify-content-center">
      <ReactUI.Col id="contact" className="homeCol" sm={8} md={8} lg={8}>
        <AnimationOnScroll className="animate__fadeInDown">
          <h1 className="text-center">Send me a message!</h1>
          <div className="text-center mb-5">
            Got a question or proposal, or just want to say hello? Go ahead.
          </div>
          <ReactUI.Form onSubmit={handleSubmit}>
            <ReactUI.Row>
              <ReactUI.Col>
                <ReactUI.FormGroup>
                  <label htmlFor="name">Your Name</label>
                  <input
                    id="name"
                    className="formK d-flex flex-column w-100"
                    type="text"
                    name="name"
                    required
                    placeholder="Enter your name"
                  />
                </ReactUI.FormGroup>
              </ReactUI.Col>
              <ReactUI.Col>
                <ReactUI.FormGroup>
                  <label htmlFor="email">Your Email</label>
                  <input
                    id="email"
                    className="formK d-flex flex-column  w-100"
                    type="email"
                    name="email"
                    required
                    placeholder="Enter your email address"
                  />
                </ReactUI.FormGroup>
              </ReactUI.Col>
            </ReactUI.Row>
            <ReactUI.FormGroup>
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                className="formK"
                type="text"
                name="subject"
                placeholder="Subject"
              />
            </ReactUI.FormGroup>
            <ReactUI.FormGroup>
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                className="formK"
                required
                placeholder="Enter your message..."
                name="message"
                rows={1}
              />
            </ReactUI.FormGroup>
            <div className="d-flex justify-content-center">
              {thankYouMsg === false ? (
                <ReactUI.Button
                  type="submit"
                  value="submit"
                  className="btnX mt-5"
                >
                  <span ref={stretchRef} className="stretch"></span>
                  <b className="paragraph">Send</b>
                </ReactUI.Button>
              ) : (
                <ReactUI.Alert variant="success" className="emailAlert">
                  Thank you for getting in touch !
                </ReactUI.Alert>
              )}
            </div>
          </ReactUI.Form>
        </AnimationOnScroll>
      </ReactUI.Col>
    </ReactUI.Row>
  );
}

export default appWrapper(ContactForm, 'contact');
